var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-list-item"},[_c('div',{staticClass:"domain one-liner"},[_vm._v(_vm._s(_vm.domain))]),_c('icon-cross',{staticClass:"btn-close",attrs:{"width":"24","height":"24","color":"#b9b9b9"},on:{"click":function($event){return _vm.$emit('deleteSetting', _vm.url.id)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }